import React from "react";
import { formHelper, networkErrorHelper } from "libs";
import { Container, Col, Button, Row } from "design-react-kit";
import { withRouter } from "react-router-dom";
import { FormEnabler, MCE, MInput, MInputFile, MLabel, MSelect, MTextArea, ValidatedForm } from "components/forms";
import { BoxDanger, BoxInfo, MnemoLoading, ModalHandler, MSection, SupportoTecnico, Title } from "components/misc";
import { ROUTES } from "const";
import { newsletterService } from "libs/api/newsletterService";

class NewsletterEmailForm extends ValidatedForm {
  emptyFields = {
    senderEmail: "",
    senderName: "",
    subject: "",
    body: "",
    template: "",
    interval: 60,
    note: "",
    document: null,
  };

  constructor(props) {
    super(props);

    // bind event handler to invoke it from the child component
    this.onChange = this.onChange.bind(this);
  }

  state = {
    loading: false,
    loadingError: false,
    emailId: 0,
    isEdit: false,
    ...this.emptyFields,
    defaultValues: {
      ...this.emptyFields,
    },
  };

  FIELDS_GROUP = [
    [
      {
        id: "senderName",
        field: "senderName",
        label: "Nome mittente",
        component: MInput,
        className: "col-md-6",
      },
      {
        id: "senderEmail",
        field: "senderEmail",
        label: "Email mittente",
        component: MInput,
        className: "col-md-6",
      },
    ],
    [
      {
        id: "template",
        field: "template",
        label: "Template",
        component: MSelect,
        payload: {
          options: [
            { label: "Selezionare", value: "" },
            { label: "Semplice", value: "semplice" },
          ],
        },
        className: "col-md-8",
      },
      {
        id: "interval",
        field: "interval",
        label: "Intervallo invio (secondi)",
        component: MInput,
        type: "number",
        className: "col-md-4",
      },
    ],
    [
      {
        id: "subject",
        field: "subject",
        label: "Oggetto",
        component: MInput,
        className: "col-md-8",
      },
      {
        field: "bodyLabel",
        label: "Corpo email",
        component: MLabel,
        className: "col-md-12 pt-2 pb-0 mb-0",
      },
      {
        id: "body",
        field: "body",
        component: MCE,
        config: {
          height: 400,
        },
        className: "col-md-12 mb-2",
      },
    ],
    [
      {
        id: "note",
        field: "note",
        label: "Note",
        component: MTextArea,
        rows: 3,
        type: "text",
        className: "col-md-12 my-3",
      },
    ],
    [
      {
        id: "document",
        field: "document",
        label: "File destinatari",
        component: MInputFile,
        config: {
          accept: ".xlsx, .xls, .csv",
          sampleFileUrl: "/assets/doc/modello_destinatari_newsletter.xlsx",
        },
        className: "col-md-12",
      },
    ],
  ];

  ERROR_MESSAGES = {
    senderEmail: "Inserire un'email valida",
    senderName: "Campo obbligatorio",
    subject: "Campo obbligatorio",
    interval: "Inserire un intervallo valido",
    template: "Campo obbligatorio",
    document: "Caricare il file destinatari",
  };

  validation = {
    senderName: (value) => value.trim() !== "",
    senderEmail: (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value),
    subject: (value) => value.trim() !== "",
    template: (value) => value.trim() !== "",
    interval: (value) => parseInt(value) > 0,
    document: (value, { isEdit }) => {
      if (isEdit) return true;
      return value !== null && value !== undefined && value !== "";
    },
  };

  componentDidMount() {
    const emailId = parseInt(this.props.match.params.emailId);

    if (emailId > 0) {
      this.setState({ isEdit: true, emailId });
      this.loadRemote(emailId);
    }
  }

  loadRemote(emailId) {
    this.setState({ loading: true });

    newsletterService
      .getNewsletterEmail(emailId)
      .then(({ data }) => {
        const { email } = data.payload;

        this.setState({
          subject: email.subject,
          loading: false,
          defaultValues: { ...this.state.defaultValues, ...email },
        });
      })
      .catch((error) => {
        console.log(error);
        networkErrorHelper.notify(error);
        this.setState({
          loading: false,
          loadingError: true,
        });
      });
  }

  onBackPage = () => {
    window.location.href = ROUTES.NEWSLETTER_EMAILS;
  };

  onSubmit = () => {
    if (!this.checkValidation()) return;

    const { subject, isEdit } = this.state;

    const title = isEdit ? "Conferma modifica Job" : "Conferma creazione Job";
    const message = isEdit
      ? `Stai per modificare il job con oggetto "${subject.value ? subject.value : subject}". Vuoi procedere?`
      : `Stai per creare un nuovo job di invio email con oggetto "${subject.value ? subject.value : subject}". Vuoi procedere?`;

    ModalHandler.show(null, title, message, null, this.saveRemote);
  };

  saveRemote = () => {
    this.setState({ loading: true });
    const { isEdit } = this.state;
    const formData = formHelper.formDataBuilder(this.state, ["document"]);

    const apiCall = isEdit ? newsletterService.updateEmailJob(formData) : newsletterService.createEmailJob(formData);

    apiCall
      .then(() => {
        this.onBackPage();
      })
      .catch((error) => {
        console.log(error);
        networkErrorHelper.notify(error);
      });
  };

  //--- ---

  render() {
    const { defaultValues, isEdit, loading, loadingError } = this.state;
    const { code } = this.renderFields(this.FIELDS_GROUP, defaultValues, true);

    return (
      <>
        {loading ? (
          <MnemoLoading />
        ) : loadingError ? (
          <BoxDanger className="m-5">
            Si è verificato un errore durante l'elaborazione della richiesta, se il problema persiste puoi <SupportoTecnico />
          </BoxDanger>
        ) : (
          <Container>
            <Row>
              <Col lg={{ size: 12 }} className="text-right">
                <Button onClick={this.onBackPage} color="btn btn-primary bg-dark p-3">
                  Torna Indietro
                </Button>
              </Col>
            </Row>

            <Title>{isEdit ? "Modifica invio email" : "Nuovo invio email"}</Title>

            {isEdit && (
              <BoxInfo>
                <strong>Nota:</strong> Stai modificando un invio già creato. Se non carichi un nuovo file, verranno mantenuti i destinatari originali.
              </BoxInfo>
            )}

            <MSection className="mb-4">
              <Container>
                <div className="mt-3 p-3">{code}</div>

                <div>
                  <FormEnabler
                    onSubmit={this.onSubmit}
                    onToggle={this.toggleForm}
                    isFormActive={true}
                    hideCancel={true}
                    buttonText={isEdit ? "Salva modifiche" : "Crea"}
                  />
                </div>
              </Container>
            </MSection>
          </Container>
        )}
      </>
    );
  }
}

export default withRouter(NewsletterEmailForm);
